/* eslint-disable */
import React, { Component } from 'react';
import HTMLText from './HTMLText'
import { timingSafeEqual } from 'crypto';

class DropDownList extends Component {

	constructor(props) {
		super(props);
		
		this.state = {	
			name : this.props.name,		
			className : this.props.className,
			dataField : this.props.dataField,
			options:this.props.options,
			curValue:this.props.curValue,
			parent:this.props.parent
		
		};
		this.onChange = this.onChange.bind(this);
	}
	
	componentDidMount() {		
	}
	
	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		
		this.setState({options:nextProps.options,curValue:nextProps.curValue});

	} 
	
	

	onChange(e){	
		this.props.parent.setState({[this.props.dataField]:e.target.value});
	
	}


	render() {
		if (this.state.options != null && this.state.options.length >0){
		var optionList = this.state.options.map((option) =>
			<option key={option.id} value={option.id}>{option.text}</option>
		
	 	 );
		}else{
			var optionList ='';
		}
		
		return (
			<React.Fragment>
				<div className={this.props.className} >
					<select onChange={this.onChange}>				
						{optionList}
					</select>					
				</div>
			</React.Fragment>			
		);
	}
}




export default DropDownList;